import { render, staticRenderFns } from "./TabelaPeticao.vue?vue&type=template&id=7586dc26&scoped=true&"
import script from "./TabelaPeticao.vue?vue&type=script&lang=js&"
export * from "./TabelaPeticao.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPeticao.vue?vue&type=style&index=0&id=7586dc26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7586dc26",
  null
  
)

export default component.exports